import getApi from '../../api/apisauceConfig'
import { QuestionnaireTemplateResource } from './mapper/questionnaireTemplate.model'
import { deserializeQuestionnaireTemplateResponse } from './mapper/questionnaireTemplate.mapper'

export const getQuestionnaireTemplate = (id: number) =>
  getApi()
    .get<QuestionnaireTemplateResource>(`/questionnaire_templates/${id}`)
    .then(deserializeQuestionnaireTemplateResponse)
